import useLocale from 'next-translate/useTranslation';
import React from 'react';

import BarwenockLogo from '~/svg/Barwenock.svg';
import BengsLogo from '~/svg/Bengs.svg';
import LalamoveLogo from '~/svg/Lalamove.svg';
import OktaLogo from '~/svg/Okta.svg';
import StripeLogo from '~/svg/Stripe.svg';
import SupabaseLogo from '~/svg/Supabase.svg';
import TailwindLogo from '~/svg/Tailwind.svg';
import TypescriptLogo from '~/svg/Typescript.svg';

// Several marks ship as white-only artwork (they were drawn for the dark
// marketing sections). `monoFill` lets a light surface swap that for grey —
// without it those logos are invisible on white.
const getLogos = (monoFill: string) => [
  {
    component: <LalamoveLogo className={`h-24 w-auto ${monoFill}`} />,
    url: 'https://nextjs.org/',
  },
  {
    component: <StripeLogo className='h-16  w-auto' />,
    url: 'https://stripe.com/',
  },
  {
    component: <TailwindLogo className={`h-16 w-auto ${monoFill}`} />,
    url: 'https://tailwindcss.com/',
  },
  {
    component: <TypescriptLogo className={`h-24 w-auto ${monoFill}`} />,
    url: 'https://www.typescriptlang.org/',
  },
  {
    component: <SupabaseLogo className={`lcp h-20 w-auto ${monoFill}`} />,
    url: 'https://supabase.com/',
  },

  {
    component: <BengsLogo className='h-24 w-auto' />,
    url: 'https://www.typescriptlang.org/',
  },
  {
    component: <BarwenockLogo className=' h-12 w-auto' />,
    url: 'https://nextjs.org/',
  },
  {
    component: <OktaLogo className={`h-24 w-auto ${monoFill}`} />,
    url: 'https://www.typescriptlang.org/',
  },
];

const LogosCloudPricing = ({
  hideManyMode = false,
  // Set on light surfaces (e.g. the in-app billing page) so the white-only
  // marks render grey instead of disappearing.
  onLightBackground = false,
}) => {
  const { t } = useLocale('common');
  const logos = getLogos(
    onLightBackground ? 'fill-gray-500 dark:fill-white' : 'fill-white',
  );

  return (
    <div className='mx-auto mt-8 w-full max-w-3xl'>
      <div className='grid w-full grid-cols-3 items-center content-center gap-2 lg:grid-cols-4'>
        {logos.map((logo, index) => {
          return (
            <div key={index} className='flex justify-center text-center'>
              {logo.component}
            </div>
          );
        })}
      </div>
      {!hideManyMode && (
        <div className='mt-6 text-xs text-gray-400'>
          {t('And many more...')}
        </div>
      )}
    </div>
  );
};

export default LogosCloudPricing;
